import React from 'react';
import {Row, Col} from 'react-bootstrap';
import moment from 'moment';

const ReportComments = ({data, loading}) => {
  if (data.length) {
    return data.map((item) => {
      return (
        <Row key={`comments-${item.id}`}>
          <Col>
            <div className="text-wrap">{item.comments}</div>
          </Col>
          <Col>
            <div className="d-flex flex-column">
              <div className="text-muted">{item.commentedBy}</div>
              <div className="text-muted mt-2" style={{fontSize: '0.850em'}}>
                {moment(item.sentOn).fromNow()}
              </div>
            </div>
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
        </Row>
      );
    });
  }
  if (!loading) {
    return <div>No Comments!</div>;
  }
  return null;
};

export default ReportComments;
